import { ValueType } from '@convergence/types';
import { useCallback } from 'react';
import { deepClone } from '../util';
import { AnalysisInputSwitch } from './analysis-input-switch';

export interface AnalysisInputRootProps {
  value: ValueType;
  analysisSchemaId: number;
  name: string;
  errors: { keyPath: string[]; message: string }[];
  onChange: (value: ValueType) => void;
}

export function AnalysisInputRoot(props: AnalysisInputRootProps) {
  const onChange = useCallback(
    (propertyPath: string[], newValue: unknown) => {
      const clone = deepClone(props.value);
      let current: any = clone;
      console.log({ propertyPath, newValue, clone });
      if (propertyPath.length === 0) {
        current._value = newValue;
      } else {
        for (const path of propertyPath) {
          if (current[path] === undefined) {
            current[path] = {};
          }
          if (path === propertyPath[propertyPath.length - 1]) {
            current[path]._value = newValue;
          } else {
            current = current[path];
          }
        }
      }
      props.onChange(clone);
    },
    [props.value, props.onChange]
  );

  return (
    <AnalysisInputSwitch
      tree={props.value}
      value={props.value}
      propertyPath={[]}
      name={props.name}
      onChange={onChange}
      errors={props.errors}
    />
  );
}
